import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import { type FC } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { useSaveLabelMaster } from 'src/features/labelMaster/api/useSaveLabelMaster'
import {
  labelMasterFormDefaultValues,
  LabelMasterSaveForm,
  type LabelMasterFormData,
} from 'src/features/labelMaster/form/LabelMasterSaveForm'

type Props = {
  open: boolean
  onClose: () => void
}

export const CreateLabelMasterDialog: FC<Props> = ({ open, onClose }) => {
  const saveMutation = useSaveLabelMaster('create')
  const history = useHistory()
  const { control, handleSubmit, reset } = useForm<LabelMasterFormData>({
    defaultValues: labelMasterFormDefaultValues,
  })

  const handleClose = () => {
    reset()
    onClose()
  }

  const onSubmit = (data: LabelMasterFormData) => {
    saveMutation.mutate(
      {
        name: data.name,
        code: data.code,
        barcodeId: data.barcodeId || undefined,
        status: data.status,
      },
      {
        onSuccess: ({ id }) => {
          handleClose()
          history.push(`/labelMasters/${id}/edit`)
        },
      },
    )
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle fontSize={20} fontWeight="bold">
        ラベルマスタを作成
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <LabelMasterSaveForm control={control} />

          <Stack direction="row" justifyContent="flex-end" gap={2}>
            <Button
              variant="text"
              size="small"
              onClick={handleClose}
              sx={{
                color: 'text.primary',
                bgcolor: grey[300],
                width: 'fit-content',
                '&:hover': { bgcolor: grey[300] },
              }}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSubmit(onSubmit)}
              disabled={saveMutation.isPending}
              sx={{ color: 'white', width: 'fit-content' }}
            >
              作成
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
